/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Entitlement_CatalogInputs */



/**
* | output |
* | --- |
* | "Changed what the plans include" |
*
* @param {Activity_Entitlement_CatalogInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_entitlement_catalog = /** @type {((inputs?: Activity_Entitlement_CatalogInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Entitlement_CatalogInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменён состав тарифов")
	return /** @type {LocalizedString} */ ("Changed what the plans include")
});